const searchableUserText = (user) => [user?.name, user?.email].filter(Boolean).join(" ");

export const tenantMatchesQuery = (tenant, query, userDirectory = {}) => {
  const normalizedQuery = String(query || "").trim().toLowerCase();
  if (!normalizedQuery) return true;

  const users = Array.isArray(userDirectory?.[tenant?.id]) ? userDirectory[tenant.id] : [];
  const searchableText = [
    tenant?.name,
    tenant?.email,
    ...(Array.isArray(tenant?.emailList) ? tenant.emailList : []),
    ...users.map(searchableUserText),
  ].filter(Boolean).join(" ").toLowerCase();

  return searchableText.includes(normalizedQuery);
};
